// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u32().primaryKey(),
  name: __t.string(),
  priceCentsMonthly: __t.u32().name("price_cents_monthly"),
  stripePriceId: __t.string().name("stripe_price_id"),
  maxPrivatePlayers: __t.u32().name("max_private_players"),
  maxSpectators: __t.u32().name("max_spectators"),
  maxFriends: __t.u32().name("max_friends"),
  monthlyCoinBonus: __t.i64().name("monthly_coin_bonus"),
  coinEarnMultiplierX100: __t.u32().name("coin_earn_multiplier_x100"),
  storeDiscountPercent: __t.u32().name("store_discount_percent"),
  dailyDealSlots: __t.u32().name("daily_deal_slots"),
  maxBioLength: __t.u32().name("max_bio_length"),
  adFree: __t.bool().name("ad_free"),
  emoteCount: __t.u32().name("emote_count"),
  bpXpMultiplierX100: __t.u32().name("bp_xp_multiplier_x100"),
  luckyTilesBonusPicks: __t.u32().name("lucky_tiles_bonus_picks"),
});
